/* Brand refresh: progressive browsing controls. Cart, delivery and discount logic stay in their existing modules. */
(() => {
  const key = 'ebd-browse-v1';
  let preference = { photo: 'product', density: 'grid' };
  try { const saved = JSON.parse(sessionStorage.getItem(key)); if (saved) { preference.photo = saved.photo === 'model' ? 'model' : 'product'; preference.density = ['large','compact'].includes(saved.density) ? saved.density : 'grid'; } } catch (_) {}
  function apply(form) {
    form.dataset.photoView = preference.photo;
    form.dataset.density = preference.density;
    form.querySelectorAll('[data-ebd-photo]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ebdPhoto === preference.photo)));
    form.querySelectorAll('[data-ebd-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ebdDensity === preference.density)));
    const modelButton = form.querySelector('[data-ebd-photo="model"]');
    const hasModels = !!form.querySelector('.has-model');
    if (modelButton) modelButton.hidden = !hasModels;
    const note = form.querySelector('[data-ebd-model-note]');
    if (note) note.hidden = preference.photo !== 'model' || !hasModels;
    form.querySelectorAll('.ebd-browse-media').forEach(media => {
      const model = media.querySelector('.ebd-photo-model');
      const product = media.querySelector('.ebd-photo-product');
      const show = !!model && preference.photo === 'model';
      if (model) {
        if (show && !model.hasAttribute('src')) {
          model.srcset = model.dataset.ebdModelSrcset;
          model.src = model.dataset.ebdModelSrc;
        }
        model.hidden = !show;
      }
      if (product) product.hidden = show;
    });
    const imageSizes = preference.density === 'large' ? '(max-width: 650px) 100vw, 50vw' : preference.density === 'compact' ? '(max-width: 650px) 33vw, 17vw' : '(max-width: 650px) 50vw, (max-width: 1000px) 33vw, 25vw';
    form.querySelectorAll('.ebd-browse-media img').forEach(img => img.sizes = imageSizes);
  }
  function initialize() {
    document.querySelectorAll('.ebd-refined-collection').forEach(form => {
      if (form.dataset.browseReady) return;
      form.dataset.browseReady = 'true';
      const controls = form.querySelector('[data-ebd-browse-controls]');
      if (!controls) return;
      controls.hidden = false;
      apply(form);
      controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.ebdPhoto) preference.photo = button.dataset.ebdPhoto;
        if (button.dataset.ebdDensity) preference.density = button.dataset.ebdDensity;
        try { sessionStorage.setItem(key, JSON.stringify(preference)); } catch (_) {}
        apply(form);
      });
      const grid = form.querySelector('.col-grid');
      if (grid) new MutationObserver(() => apply(form)).observe(grid, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-eh-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.ehOpen);
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.body.classList.add('eh-dialog-open');
    if (dialog.id === 'eh-search') dialog.querySelector('input[type="search"]')?.focus();
  });
  // Restyle the existing signup only; its Klaviyo actions and audience rules remain intact.
  function prepareSignup() {
    const form = document.querySelector('[data-testid="klaviyo-form-VpK5LY"]');
    if (!form) return;
    const logo = form.querySelector('.klaviyo-form-image img');
    const originalLogo = document.querySelector('.eh-logo img');
    if (logo && originalLogo && logo.src !== originalLogo.src) {
      logo.src = originalLogo.src;
      logo.removeAttribute('srcset');
      logo.alt = originalLogo.alt;
      logo.width = 134;
      logo.height = 58;
    }
    const campaign = form.querySelector(':scope > div:first-child > div > img');
    if (campaign) campaign.alt = 'Flame workshirts from Engineered by Dré';
  }
  prepareSignup();
  new MutationObserver(prepareSignup).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const watched = new WeakSet();
  const active = new Set();
  const animated = new WeakMap();
  const selectors = [
    '.eh-home [data-eh-reveal]:not(.eh-story-image)',
    '.eh-section-head', '.eh-norm-intro', '.eh-norm-details',
    '.eh-newsletter > div', '.ebd-bundle-station',
    '.ebd-vp-heading', '.ebd-vp-progress',
    '.ebd-refined-collection .pcell'
  ].join(',');

  function settle(element, frames, duration = 560, delay = 0) {
    if (motion.matches || !element?.animate || !element.isConnected) return;
    animated.get(element)?.cancel();
    const animation = element.animate(frames, {
      duration, delay, easing: 'cubic-bezier(.2,.7,.25,1)', fill: 'none'
    });
    animated.set(element, animation);
    active.add(animation);
    const done = () => active.delete(animation);
    animation.addEventListener('finish', done, { once: true });
    animation.addEventListener('cancel', done, { once: true });
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting);
    visible.forEach((entry, index) => {
      observer.unobserve(entry.target);
      settle(entry.target, [
        { opacity: .72, translate: '0 14px' },
        { opacity: 1, translate: '0 0' }
      ], 560, Math.min(index * 55, 165));
    });
  }, { threshold: .06 }) : null;

  function initialize(root = document) {
    if (!observer) return;
    root.querySelectorAll(selectors).forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      const box = element.getBoundingClientRect();
      if (!motion.matches && box.height && box.top >= window.innerHeight) observer.observe(element);
    });
    root.querySelectorAll('.ebd-vp-photo img').forEach(image => {
      if (image.dataset.ebdMotionReady) return;
      image.dataset.ebdMotionReady = 'true';
      image.addEventListener('load', () => {
        const box = image.getBoundingClientRect();
        if (!box.height || box.bottom < 0 || box.top > innerHeight) return;
        settle(image, [{ opacity: .6, scale: '.97' }, { opacity: 1, scale: '1' }], 320);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-ebd-pair-open]')) return;
    requestAnimationFrame(() => initialize());
  });
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    observer?.disconnect();
    active.forEach(animation => animation.cancel());
    active.clear();
  });
})();
